<p-drawer
    [(visible)]="app.ReportsSideNavVisible"
    style="min-width: 35vw; max-width: 90vw; width: 50vw; height: 100vh;"
    position="right"
    [modal]="true"
    appendTo="body"
    baseZIndex="2000"
    [blockScroll]="true"
    [showCloseIcon]="true"
    (onHide)="app.onReportsSideNavHide()"
    (onShow)="app.onReportsSideNavShow()"
>
    <ng-template #header styleClass="mb-1">
        <div class="flex align-items-center justify-content-between">
            <div class="text-xl font-bold">Reports</div>
        </div>
    </ng-template>

    <ng-form [formGroup]="reportForm">

        <div class="grid">
            <div class="col col-12" [hidden]="!msgs || msgs.length === 0">
                <p-messages [(value)]="msgs"></p-messages>
            </div>
        </div>
        <!-- <p-toolbar>
            <div [hidden]="!useScheduledDates.checked">
                <p-floatLabel variant="on">
                    <p-select
                        id="ddlScheduledDate"
                        [filter]="true"
                        [autoDisplayFirst]="false"
                        [options]="scheduledDateItems"
                        appendTo="body"
                        baseZIndex="20001002"
                        [formControl]="this.reportForm.controls['scheduledDates']"
                        styleClass="w-full"
                        >
                    </p-select>
                    <label for="ddlScheduledDate">Company Dates</label>
                </p-floatLabel>
            </div>
            <div [hidden]="useScheduledDates.checked">
                <p-floatLabel variant="on">
                    <p-datepicker
                        styleClass="w-full"
                        selectionMode="range"
                        [monthNavigator]="true"
                        [yearNavigator]="true"
                        yearRange="2000:2030"
                        [formControl]="this.reportForm.controls['reportDates']">
                    </p-datepicker>
                    <label>Date Range</label>
                </p-floatLabel>
            </div>
            <div class="flex items-center">
                <p-checkbox id="useScheduledDates" #useScheduledDates [formControl]="this.reportForm.controls['useScheduledDates']"
                    ariaLabelledBy="lblScheduledDates" [binary]="true"></p-checkbox>
                <label class="ml-2" id="lblScheduledDates" for="useScheduledDates">Use Company Dates</label>
            </div>
        </p-toolbar> -->

        <div class="grid mt-1">
            <div class="col-4 sm:col-12 md:col-12 lg:col-12 xl:col-4 mt-1">
                <div class="grid">
                    <div class="col-12">
                        <p-panel header="Report Dates" >
                            <div class="pull-left reporting-params-header mb-2">
                                <div class="flex items-center">
                                    <p-checkbox id="useScheduledDates" #useScheduledDates [formControl]="this.reportForm.controls['useScheduledDates']"
                                        ariaLabelledBy="lblScheduledDates" [binary]="true"></p-checkbox>
                                    <label class="ml-2" id="lblScheduledDates" for="useScheduledDates">Use Company Dates</label>
                                </div>
                            </div>
                            <div [hidden]="!useScheduledDates.checked">
                                <p-floatLabel variant="on">
                                    <p-select
                                        id="ddlScheduledDate"
                                        [filter]="true"
                                        [autoDisplayFirst]="false"
                                        [options]="scheduledDateItems"
                                        appendTo="body"
                                        baseZIndex="20001002"
                                        [formControl]="this.reportForm.controls['scheduledDates']"
                                        styleClass="w-full"
                                        >
                                    </p-select>
                                    <label for="ddlScheduledDate">Company Dates</label>
                                </p-floatLabel>
                            </div>
                            <div [hidden]="useScheduledDates.checked">
                                <p-datepicker
                                    styleClass="w-full"
                                    selectionMode="range"
                                    [monthNavigator]="true"
                                    [yearNavigator]="true"
                                    yearRange="2000:2030"
                                    [formControl]="this.reportForm.controls['reportDates']">
                                </p-datepicker>
                            </div>
                        </p-panel>
                    </div>
                    <div class="col-12">
                        <p-panel header="Direct Reports" >
                            <div class="pull-left reporting-params-header mb-2">
                                <div class="flex items-center">
                                    <p-checkbox
                                        inputId="chkShowAllPeople"
                                        #chkShowAllPeople
                                        [formControl]="
                                            this.reportForm.controls['showAllPeople']
                                        "
                                        binary="true"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Include Inactive People"
                                    ></p-checkbox>
                                    <label class="ml-2" for="chkShowAllPeople">Include Inactive</label>
                                </div>

                            </div>
                            <p-multiselect
                                [options]="directReportItems"
                                [formControl]="reportForm.controls['selectedPeople']"
                                optionLabel="EmployeeName"
                                placeholder="Select Direct Reports"
                                display="chip"
                                styleClass="w-full mb-2"
                                appendTo="body"
                                [disabled]="directReportItems?.length === 0"></p-multiselect>
                        </p-panel>
                    </div>
                    <div class="col-12">
                        <p-panel header="Contracts" >
                            <div class="pull-left reporting-params-header mb-2">
                                <div class="flex items-center">
                                    <p-checkbox
                                        inputID="chkShowAllContracts"
                                        #chkShowAllContracts
                                        [formControl]="
                                            this.reportForm.controls['showAllContracts']
                                        "
                                        binary="true"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Include Inactive Contracts"
                                    ></p-checkbox>
                                    <label class="ml-2" for="chkShowAllContracts">Include Inactive</label>
                                </div>

                            </div>
                            <p-multiselect
                                [options]="contractItems"
                                [formControl]="reportForm.controls['selectedContracts']"
                                optionLabel="ContractDesc"
                                placeholder="Select Contracts"
                                display="chip"
                                styleClass="w-full mb-2"
                                appendTo="body"
                                [disabled]="contractItems?.length === 0">
                                <ng-template let-contract #item>
                                    <div class="flex items-center gap-2">
                                        <div>{{ contract.ContractDesc }}</div>
                                        <div>[ {{ contract.ContractType }} ]</div>
                                    </div>
                                </ng-template>
                            </p-multiselect>
                        </p-panel>
                    </div>
                </div>
            </div>
            <div class="col-8 sm:col-12 md:col-12 lg:col-12 xl:col-8 mt-1">
                <p-panel class="treetable-panel">
                    <div class="flex justify-content-end mt-3 mr-3">
                        <button
                            pButton
                            class="mr-3"
                            severity="success"
                            aria-label="Run"
                            raised
                            icon="pi pi-play-circle"
                            label="Run"
                            title="Run Report(s)"
                            (click)="runReports(selectedReports)"
                            [disabled]="
                                !(this.selectedReports?.length > 0) ||
                                (reportForm.controls['useScheduledDates'].value &&
                                    !reportForm.controls['scheduledDates'].value) ||
                                (!reportForm.controls['useScheduledDates'].value &&
                                    !reportForm.controls['reportDates'].value)
                            "
                        ></button>
                        <p-splitButton
                            label="Clear"
                            raised
                            text
                            aria-label="Clear"
                            title="Clear Filters/Reports/All"
                            [model]="clearOptions"
                            (onClick)="onClear()"
                            severity="info"
                        ></p-splitButton>
                    </div>
                    <p-tree
                        [filter]="true"
                        filterMode="strict"
                        filterPlaceholder="Search for report(s)"
                        #reportTree
                        id="reportTree"
                        [value]="reports"
                        selectionMode="checkbox"
                        [(selection)]="selectedReports"
                        (onNodeSelect)="onNodeSelect($event)"
                        (selectionChange)="onSelectionChange($event)"
                        scrollHeight="flex"
                        [style]="treestyle"
                    >
                        <ng-template pTemplate="default" let-node>
                            <div class="flex align-items-center justify-content-between w-full">
                                <span class="flex-grow-1">{{ node.label }}</span>
                                <button
                                    *ngIf="!node.children || node.children.length === 0"
                                    pButton
                                    type="button"
                                    [icon]="isFavorite(node) ? 'pi pi-star-fill' : 'pi pi-star'"
                                    class="p-button-text p-button-sm ml-2"
                                    [class.text-yellow-500]="isFavorite(node)"
                                    (click)="toggleFavorite(node, $event)"
                                    [title]="isFavorite(node) ? 'Remove from favorites' : 'Add to favorites'"
                                    pTooltip="Toggle favorite"
                                    tooltipPosition="top">
                                </button>
                            </div>
                        </ng-template>
                    </p-tree>
                </p-panel>
            </div>
        </div>

    </ng-form>

</p-drawer>


